import React, { Component } from 'react';
import moment from 'moment'
import Chart from 'chart.js'
import { SERVER_URL } from './ServerConfig'
import { formatNumber } from './Utils'
import "react-datepicker/dist/react-datepicker.css";
import { BeatLoader } from 'react-spinners' 

class EnergyChartOfYear extends Component {

    constructor(props) {
        super(props);

        this.state = {
            date : new Date(),
            isReady : false,
        }

        this.shouldUpdateUI = true;
        this.handlePreviousYear = this.handlePreviousYear.bind(this);
        this.handleNextYear = this.handleNextYear.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }

    componentDidMount() {
        this.fetchMonthSummary(this.state.date);
    }

    componentWillUnmount() {
        this.shouldUpdateUI = false;
    }

    fetchMonthSummary(date) {
        const token = this.props.user.payload.token;
        const station = this.props.station;

        let year = moment(date).toISOString();
        fetch(SERVER_URL + '/v1/stations/' + station._id + '/getEnergySummaryOfYear', {
            method: 'post',
            headers: {  
                'Content-Type': 'application/json',
                'x-access-token': token,
            },
            body: JSON.stringify({
                year : year
            })
        })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    this.props.history.push("/login");
                }
            })
            .then(data => {
                if (!this.shouldUpdateUI) {
                    return;
                }
                let content = data.content;
                let keys = Object.keys(content);

                let keyData = [];
                keys.forEach(e => {
                    keyData.push(e)
                });

                let values = Object.values(content);

                let valuesData = [];
                values.forEach(e => {
                    if (e >= 0) {
                        valuesData.push(formatNumber(e));
                    }
                });

                this.setState({ isReady : true });
                this.drawColumnCanvas(keyData, valuesData);
            })
    }

    drawColumnCanvas(keys, values) {
        var ctx = document.getElementById('myChart');
        let colors = []
        values.forEach(v => {
            colors.push('rgba(247,70,74,1)');
        });
        if (ctx) {
            var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: keys,
                    datasets: [{
                        label: 'Energy (kWh)',
                        data: values,
                        borderColor: colors,
                        backgroundColor: colors,
                        borderWidth: 1.5,
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                maxTicksLimit: 5
                            }
                        }]
                    }
                }
            });
        }
    }


    handlePreviousYear(event) {
        let date = this.state.date;
        let previousMonth = moment(date).subtract(1, 'year').toDate();
        
        this.setState({
            date : previousMonth,
            isReady : false,
        })
        this.fetchMonthSummary(previousMonth);
    }

    handleNextYear(event) {
        let date = this.state.date;
        let nextMonth = moment(date).add(1, 'year').toDate();
        this.setState({
            date: nextMonth,
            isReady : false,
        })
        this.fetchMonthSummary(nextMonth);
    }

    handleRefresh(event) {
        this.setState({
            isReady : false,
        })
        this.fetchMonthSummary(this.state.date);
    }

    handleReset(event) {
        let currentDate = new Date();
        this.setState({
            date : currentDate,
            isReady : false,
        })
        this.fetchMonthSummary(currentDate);
    }

    getCurrentYear() {
        return moment(this.state.date).format('YYYY');
    }

    getCalendarContent() {
        if (!this.state.isReady) {
            return (
                <div className="main-content d-flex justify-content-center mt-5">
                    <BeatLoader size={30} color="#4A90E2"/>
                </div>
            );
        }
        return (
            <canvas id="myChart" height="500"></canvas>
        )
    }

    render() {
        return (
            <div className="col-sm-12">
                <div className="d-flex justify-content-center energy-chart-header">
                    <button type="button" className="btn btn-default btn-sm none-border" onClick={this.handlePreviousYear}>
                        <i className="fa fa-chevron-left"></i>
                    </button>
                    <div className="d-flex col-sm-3">
                        <input type="text" className="day-picker-input form-control form-control-sm" value={this.getCurrentYear()} readOnly/>
                    </div>
                    <button type="button" className="btn btn-default btn-sm none-border" onClick={this.handleNextYear}>
                        <i className="fa fa-chevron-right"></i>
                    </button>
                    <button type="button" className="btn btn-default btn-sm none-border" onClick={this.handleRefresh}>
                        <i className="fa fas fa-sync-alt"></i>
                    </button>
                    <button type="button" className="btn btn-default btn-sm none-border" onClick={this.handleReset}>
                        <i className="fas fa-reply"></i>
                    </button>
                </div>
                <div className="d-flex justify-content-center mt-2">
                   {this.getCalendarContent()}
                </div>
            </div>
        );
    }
}

export default EnergyChartOfYear;